module.exports = __webpack_public_path__ + "img/345_method_splash.cf885b80.jpg";